import { useI18n, useMCAInfo } from 'contexts/AuthContext'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ContentHeader from '../ContentHeader'
import CareSelectButton from 'components/CareSelectButton/index'
import { Button } from 'antd'
import { isMobile } from 'utils/basic'
import _ from 'lodash'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { useMCA } from './useMCA'
import { ScreenKey } from '../util'

const MSKPainQualifierOptions = [
  {
    id: 1,
    name: 'Yes',
    value: 'yes',
  },
  {
    id: 2,
    name: 'No',
    value: 'no',
  },
]
const MSKPainQualifier = (props) => {
  const { i18n } = useI18n()
  const { sku, setCurrentKey } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { setMCAInfo, mcaInfo } = useMCAInfo()
  const { getNextScreenKey } = useMCA({ sku })
  const { mskPainQualifier = [] } = mcaInfo

  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - MSK Pain Qualifier', {
      sku,
    })
  }, [sku])

  const isSelected = (id) => {
    return mskPainQualifier.some((item) => item.id === id)
  }

  const setSelected = (item) => {
    const isExist = isSelected(item.id)
    if (isExist) {
      setMCAInfo({
        ...mcaInfo,
        mskPainQualifier: [],
      })
    } else {
      setMCAInfo({ ...mcaInfo, mskPainQualifier: [item] })
    }
  }

  const isNextButtonEnable = useMemo(() => {
    return !_.isEmpty(mskPainQualifier)
  }, [mskPainQualifier])

  const openNextScreen = useCallback(async () => {
    const nextScreenKey = await getNextScreenKey(
      ScreenKey.MCA_MSK_PAIN_QUALIFIER
    )
    setCurrentKey(nextScreenKey)
  }, [setCurrentKey, getNextScreenKey])

  const onSubmit = async () => {
    setIsSubmitting(true)
    logAmplitudeEvent('Click: Onboarding - MSK Pain Qualifier - Submit', {
      sku,
      response: mskPainQualifier[0].value,
    })

    await openNextScreen()
    setIsSubmitting(false)
  }

  return (
    <div className='info-sec'>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title-pns' style={{ marginBottom: '32px' }}>
          {i18n(
            'Do you have joint or muscle pain, lasting more than 2 weeks, and does it affect your daily movement or activities?'
          )}
        </div>
        {MSKPainQualifierOptions.map((item, index) => (
          <div key={index}>
            <CareSelectButton
              key={index}
              {...{
                selected: isSelected(item.id),
                setSelected: () => {
                  setSelected(item)
                },
                text: item.name,
                className: 'm-b-12 center-align',
                textAlign: 'center',
              }}
            />
          </div>
        ))}
        <Button
          className='btn-primary full-width-btn'
          style={isMobile() ? { width: '100%' } : {}}
          onClick={onSubmit}
          disabled={!isNextButtonEnable}
          loading={isSubmitting}
        >
          {i18n('Next')}
        </Button>
      </div>
    </div>
  )
}

export default MSKPainQualifier
